import { render, staticRenderFns } from "./SelectAnswer.vue?vue&type=template&id=359029e1&scoped=true"
import script from "./SelectAnswer.vue?vue&type=script&lang=js"
export * from "./SelectAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359029e1",
  null
  
)

export default component.exports